// This file is modified during CI builds. Do not change this
// file unless you know what you are doing
const APPLICATION_VERSION = "v1.455.75-TSS-3004-mcastro-IMPROVEMENT-Archive-Templates-from-Workspace.1";

export const getApplicationVersion = (): string => APPLICATION_VERSION;
